export default __webpack_public_path__ + "static/media/feat-lock.819d83ec.svg";